import { render, staticRenderFns } from "./MarketingCompanyController.vue?vue&type=template&id=59f498fb"
import script from "./MarketingCompanyController.vue?vue&type=script&lang=js"
export * from "./MarketingCompanyController.vue?vue&type=script&lang=js"
import style0 from "./MarketingCompanyController.vue?vue&type=style&index=0&id=59f498fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports